import { observer } from "mobx-react";
import { Button } from "primereact/button";
import { classNames } from "primereact";
import { useContext, useState } from "react";
import {
  DesktopClient,
  DeviceType,
} from "../../../api/firebase/types/device.types";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import ToastContext from "../../../components/toast/ToastContext";
import DeviceStore from "../../../store/DeviceStore";
import { DeviceToasts } from "../../../toastMessages/deviceToastMessages";

type DeviceSettingsHeader = {
  currentDevice: DeviceType | DesktopClient;
  setShowLoader: (show: boolean) => void;
};

const DeviceSettingsHeader: React.FC<DeviceSettingsHeader> = (props) => {
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);

  const showToast = useContext(ToastContext);

  const handleDeleteDeviceClicked = async () => {
    props.setShowLoader(true);
    const { deviceDeleted, deviceDeletionError } = DeviceToasts;
    const deletionSucceeded = await DeviceStore.deleteCurrentDevice();
    showToast(deletionSucceeded ? deviceDeleted : deviceDeletionError);
    props.setShowLoader(false);
  };

  return (
    <>
      <Button
        className={classNames("p-mr-2", {
          "p-button-danger": props.currentDevice.deviceTestMode,
          "p-button-outlined p-button-warning":
            !props.currentDevice.deviceTestMode,
        })}
        key="test-mode-button"
        style={{ height: 40 }}
        label={`Testmodus ${
          props.currentDevice.deviceTestMode ? "deaktivieren" : "aktivieren"
        }`}
        onClick={() =>
          DeviceStore.updateCurrentDevice({
            deviceTestMode: !props.currentDevice?.deviceTestMode,
          })
        }
      />
      <Button
        key="delete-button"
        icon="pi pi-trash"
        className="p-button-outlined p-button-danger"
        style={{ height: 40 }}
        label="Entfernen"
        onClick={() => setShowDeleteDialog(true)}
      />
      <ConfirmDialog
        header="Meldeinstanz entfernen?"
        content="Willst du die Meldeinstanz wirklich entfernen?"
        isVisible={showDeleteDialog}
        onHide={() => setShowDeleteDialog(false)}
        onClickYes={handleDeleteDeviceClicked}
      />
    </>
  );
};

export default observer(DeviceSettingsHeader);
